import { useEffect } from "react";
import { useCookieConsent } from "../hooks/useCookieConsent";

const LEADINFO_ID = "LI-6960E1A357612";

declare global {
  interface Window {
    GlobalLeadinfoNamespace?: string[];
    leadinfo?: (...args: any[]) => void;
  }
}

export function Leadinfo() {
  const { hasMarketingConsent } = useCookieConsent();

  useEffect(() => {
    if (!hasMarketingConsent) {
      return;
    }

    // If already loaded, return early
    if (typeof window !== "undefined" && window.leadinfo) {
      return;
    }

    // Load Leadinfo script only after consent
    (function (
      l: any,
      e: any,
      a: any,
      d: any,
      i: any,
      n?: any,
      f?: any,
      o?: any
    ) {
      if (!l[i]) {
        l.GlobalLeadinfoNamespace = l.GlobalLeadinfoNamespace || [];
        l.GlobalLeadinfoNamespace.push(i);
        l[i] = function () {
          (l[i].q = l[i].q || []).push(arguments);
        };
        l[i].t = l[i].t || n;
        l[i].q = l[i].q || [];
        o = e.createElement(a);
        f = e.getElementsByTagName(a)[0];
        o.async = 1;
        o.src = d;
        f.parentNode.insertBefore(o, f);
      }
    })(
      window,
      document,
      "script",
      "https://cdn.leadinfo.eu/ping.js",
      "leadinfo",
      LEADINFO_ID
    );
  }, [hasMarketingConsent]);

  return null;
}
